var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage starts-with"
  }, [_c('div', {
    staticClass: "steps-container"
  }, [_c('figure', {
    staticClass: "step-image"
  }, [_vm.currentStep.imagePath ? _c('img', {
    attrs: {
      "src": _vm.currentStep.imagePath
    }
  }) : _vm._e()]), _c('text-display-list', {
    staticClass: "text-steps",
    attrs: {
      "text-size": _vm.textSize
    }
  }, _vm._l(_vm.currentRound.steps, function (step) {
    return _c('li', {
      key: ((_vm.currentRound.roundIndex) + "-" + (step.stepIndex)),
      class: ("step step-" + (step.stepIndex))
    }, [_c('color-block-text', {
      attrs: {
        "text": step.answer,
        "text-step": step.stepIndex
      }
    })], 1);
  }), 0)], 1), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }